import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export const socials = {
  instagram: {
    label: "Instagram",
    bg: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
    icon: FaInstagram,
  },
  facebook: {
    label: "Facebook",
    bg: "#1877f2",
    icon: FaFacebookF,
  },
  twitter: {
    label: "Twitter / X",
    bg: "#000000",
    icon: FaXTwitter,
  },
  linkedin: {
    label: "LinkedIn",
    bg: "#0a66c2",
    icon: FaLinkedinIn,
  },
};